import classNames from "classnames";
import Button from "../Button";

const SliderArrow = ({
  direction, slide, endReached, name,
}) => (
  <div
    className={classNames(
      "slider-button",
      name && `slider-button-${name}`,
      `slider-button-${direction === -1 ? "left" : "right"}`,
      endReached && "disabled",
    )}
  >
    <Button
      variant="ghost-dark"
      size="sm"
      leftIconName={`${direction === -1 ? "chevron-left" : "chevron-right"}`}
      className="slider-arrow-btn bg-white"
      onClick={() => slide(direction)}
      disabled={endReached}
    />
  </div>
);

export default SliderArrow;
